import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BLOG_TIEMPO } from "@/components/PopupTiempo";

export default function MiTiempo() {
  const { user } = useAuth();
  const [uso, setUso] = useState(null);
  const nombre = (user?.nombre || "").split(" ")[0];

  useEffect(() => {
    api.get("/momentos/estado").then(({ data }) => setUso(data.uso_tiempo || null)).catch(() => {});
  }, []);

  return (
    <div className="min-h-full px-6 py-16" style={{ background: "#0A0A0A" }} data-testid="pagina-mi-tiempo">
      <div className="mx-auto" style={{ maxWidth: 680 }}>
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <div className="mono-label mb-4" style={{ color: "#C9A84C" }}>Y AHORA</div>
          <h1 className="font-serif" style={{ fontSize: "clamp(28px, 4vw, 44px)", color: "#EDEDED", lineHeight: 1.2 }} data-testid="mi-tiempo-titulo">
            ¿Qué hago con mi tiempo?
          </h1>
          <div className="font-serif mt-6 space-y-4" style={{ fontSize: "clamp(18px, 2.2vw, 22px)", color: "#CFCFCF", lineHeight: 1.6 }}>
            <p>{nombre ? `${nombre}, ya` : "Ya"} recuperaste horas reales. La parte difícil está hecha.</p>
            <p>Lo que sigue no es automatizar más. Es decidir en qué vas a usar ese tiempo, antes de que se llene solo de más de lo mismo.</p>
            <p style={{ color: "#C9A84C" }}>Nadie planifica el tiempo que gana. Por eso lo pierde.</p>
          </div>

          {uso && (
            <div className="mt-8 rounded-xl p-5" style={{ background: "#0F0F0F", border: "1px solid #262626" }} data-testid="mi-tiempo-uso">
              <div className="mono-label mb-2" style={{ color: "#8A8A8A" }}>LO QUE ESCRIBISTE CUANDO ARRANCASTE</div>
              <p className="font-serif" style={{ fontSize: 20, color: "#EDEDED" }}>“{uso}”</p>
            </div>
          )}

          <a href={BLOG_TIEMPO} target="_blank" rel="noopener noreferrer" data-testid="mi-tiempo-blog-link"
            className="inline-flex items-center gap-2 mt-10 rounded-full px-8 py-3 transition-transform hover:scale-[1.03]"
            style={{ background: "#C9A84C", color: "#0A0A0A", fontSize: 15, fontWeight: 600, letterSpacing: "0.02em" }}>
            Leer la nota <ArrowUpRight size={18} />
          </a>
        </motion.div>
      </div>
    </div>
  );
}
